'use client'

import { usePreferenceSync } from '@/hooks/use-preference-sync'
import { showToast } from '@/lib/utils/toast'
import { useEffect } from 'react'

/**
 * PreferenceSync - Component that handles synchronization of user preferences
 * between local storage and server when authentication state changes
 *
 * This is a utility component with no visual output, but it handles:
 * - Automatic sync on login
 * - Error handling and retry logic for failed syncs
 * - Conflict resolution between local and server preferences
 */
export function PreferenceSync() {
  // Use the preference sync hook to handle synchronization
  const { isSyncing, syncComplete, hasLocalPreferences, error, lastSyncTime } = usePreferenceSync()

  // Display toast notification for sync completion
  useEffect(() => {
    if (syncComplete && lastSyncTime && hasLocalPreferences) {
      showToast({
        title: 'Your preferences have been synchronized',
        color: 'success',
        timeout: 3000
      })
    }
  }, [syncComplete, lastSyncTime, hasLocalPreferences])

  // Display persistent error notification
  useEffect(() => {
    if (error) {
      showToast({
        title: 'Failed to sync preferences',
        description: error,
        color: 'danger',
        timeout: 5000
      })
    }
  }, [error])

  // This component doesn't render anything
  return null
}
